import React from 'react';
import { MetaLayerDefinition, useLayers, WMSLayerProperties } from '@agissc/ktag-map';
import { useLegendQuery } from '../../mapContent/api/useLegendQuery';
import LegendSymbols from '../../legend/LegendSymbols';
import WmsLegend from '../../legend/WmsLegend';
import GeoAdminLegend from '../../legend/GeoAdminLegend';
import Scrollable from '../../../components/scrollable/Scrollable';
import useAppState from '../../../AppStore';
import { IdentifyLegendProps } from '../api/contract';
import { WMTSLayerDefinition } from '../../../poc/Contracts';

interface LegendContentProps {
  topicLayer: MetaLayerDefinition;
  identifyLegend: IdentifyLegendProps;
}

const LegendContent = ({
  topicLayer,
  identifyLegend,
}: LegendContentProps): React.JSX.Element | null => {
  switch (topicLayer.source) {
    case 'topicmaps.geo.ag.ch': {
      const legendQuery = useLegendQuery(
        topicLayer.url,
        topicLayer.isPublic !== undefined ? topicLayer.isPublic : true,
      );
      if (legendQuery.isLoading) return null;
      const legends = legendQuery.data ?? {};
      const legend = legends[identifyLegend.layerId];
      return <LegendSymbols legend={legend} title={identifyLegend.title} isRoot />;
    }
    case 'wms.geo.ag.ch':
      return (
        <WmsLegend layerName={(topicLayer.properties as WMSLayerProperties).layernames} />
      );
    case 'wms.geo.admin.ch': {
      if (topicLayer.type === 'wmts') {
        return (
          <GeoAdminLegend
            layerName={(topicLayer.properties as WMTSLayerDefinition).layername}
          />
        );
      }
      return (
        <GeoAdminLegend
          layerName={(topicLayer.properties as WMSLayerProperties).layernames}
        />
      );
    }
    default:
      return null;
  }
};

const IdentifyLegend = () => {
  const layersQuery = useLayers();
  const identifyLegend = useAppState((state) => state.identifyLegend);

  if (layersQuery.isLoading) return null;

  const topicLayers = layersQuery.data ?? {};
  const topicLayer = topicLayers[identifyLegend.topicLayerId];
  return (
    <Scrollable
      additionalClassName="tooldialog__wrapper-content"
      scrollAdditionClassName="tooldialog__wrapper-content--scrollable"
    >
      <div key={`legend-${topicLayer.id}`} className="legend-group">
        <h3 className="legend__title">{topicLayer.title}</h3>
        <LegendContent topicLayer={topicLayer} identifyLegend={identifyLegend} />
      </div>
    </Scrollable>
  );
};

export default IdentifyLegend;
